<template>
	<b-modal
		ref="select-incidence-modal"
		:title="`Asignar Incidencia`"
		no-close-on-backdrop
		centered
		@hidden="handleHidden"
		size="md"
	>
		<ValidationObserver ref="form">
			<b-row>
				<b-col class="input-select-corral" cols="12">
					<b-form-group id="input-group-1" label="Incidencias:" label-for="input-1">
						<ValidationProvider rules="required" v-slot="{ errors }">
							<v-select
								v-model="incidence_id"
								:options="incidences"
								:clearable="false"
								label="name"
								:reduce="(option) => option.id"
								:class="{ 'border-danger rounded': errors[0] }"
							>
								<template v-slot:option="option">
									<div class="d-flex justify-content-between align-items-center">
										<span>{{ option.name }}</span>
									</div>
								</template>
							</v-select>
							<span v-if="errors[0]" class="text-danger">{{ errors[0] }}</span>
						</ValidationProvider>
					</b-form-group>
				</b-col>
			</b-row>
		</ValidationObserver>
		<template #modal-footer>
			<b-button @click="$emit('hidden')" v-if="!isLoading" variant="secondary">Cancelar</b-button>
			<b-button variant="secondary" disabled v-else>
				<b-spinner small />
				Cargando...
			</b-button>
			<b-button variant="outline-primary" @click="save" v-if="!isLoading">Guardar</b-button>
			<b-button variant="outline-primary" disabled v-else>
				<b-spinner small />
				Cargando...
			</b-button>
		</template>
	</b-modal>
</template>

<script>
import SpecimenPlate from "@/components/specimens/SpecimenPlate.vue"
import ViewImage from "@/components/commons/ViewImage.vue"
import PreparationIncidencesService from "@/views/brain/preparacion/services/preparation-incidence.service.js"
import PreparacionService from "@/services/preparacion/default.service.js"
import { mapActions } from "vuex"
export default {
	components: { SpecimenPlate, ViewImage },
	props: {
		training: {
			type: Object,
		},
		statusId: {
			type: Number,
			default: null,
		},
	},
	data() {
		return {
			isLoading: false,
			incidences: [],
			incidence_id: null,
		}
	},
	methods: {
		...mapActions({
			A_GET_INCIDENCES_COUNTER: "commons/A_GET_INCIDENCES_COUNTER",
		}),
		handleHidden() {
			this.isLoading = false
			this.$emit("closing")
		},
		async getDetails() {
			this.isPreloading()
			try {
				const { data } = await PreparationIncidencesService.getIncidences({
					active: 1,
				})
				this.incidences = data
			} catch (error) {
				console.log(error)
			} finally {
				this.isPreloading(false)
			}
		},
		async save() {
			try {
				this.isLoading = true
				if (!this.incidence_id) return
				await PreparacionService.savePreparationIncidence({
					incidence_id: this.incidence_id,
					training_id: this.training.training_id,
					status_id: this.statusId,
				})
				this.A_GET_INCIDENCES_COUNTER()
				this.$emit("refresh")
				this.handleHidden()
			} catch (error) {
				console.error("Error saving incidence:", error)
			} finally {
				this.isLoading = false
			}
		},
	},
	watch: {},
	async mounted() {
		await this.getDetails()
		this.$refs["select-incidence-modal"].toggle()
	},
}
</script>

<style>
.label-filter {
	font-size: 0.8rem;
}

.nav.nav-tabs {
	flex-wrap: nowrap;
	overflow-x: auto;
	padding-bottom: 0.5rem;
}

.nav-link {
	white-space: nowrap;
}
</style>
